// extracted by mini-css-extract-plugin
export default {"input":"DecimalInput_input__YqvUN"};